import { Modal as BaseModal, Button, Spin } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type Bundle from 'stores/Bundle';

import BundleElementRow from './BundleElementRow';
import CopyBundleUrlsButton from './CopyBundleUrlsButton';

const Modal = styled(BaseModal)`
  .ant-modal-body {
    height: 60vh;
    padding: 0;
    overflow: auto;
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export interface BundleReportModalProps {
  bundle: Bundle;
  isVisible: boolean;
  onClose: () => void;
}

function BundleReportModal({
  bundle,
  isVisible,
  onClose,
}: BundleReportModalProps) {
  const bundleElements = bundle.elements.all;

  const spinner = (
    <SpinnerContainer>
      <Spin />
    </SpinnerContainer>
  );

  const bundleElementsRows = bundleElements.map((element) => (
    <BundleElementRow
      bundle={bundle}
      element={element}
      key={`${bundle.id} ${element.id}`}
    />
  ));

  const footerButtons = (
    <>
      <CopyBundleUrlsButton bundle={bundle} format="labeled-urls">
        Copy URLs (Labeled)
      </CopyBundleUrlsButton>

      <CopyBundleUrlsButton bundle={bundle} format="urls-only">
        Copy URLs
      </CopyBundleUrlsButton>

      <Button onClick={onClose}>Cancel</Button>
    </>
  );

  return (
    <Modal
      title="Bundle Details"
      footer={footerButtons}
      open={isVisible}
      width={700}
      onCancel={onClose}
    >
      {bundle.elements.mounted ? bundleElementsRows : spinner}
    </Modal>
  );
}

export default observer(BundleReportModal);
